import { createAction, props } from '@ngrx/store';
import { Note } from '@xpo-ltl/sdk-linehaulpayform';

interface AddNoteProps {
  note: Note;
}

interface UpdateNoteProps {
  note: Note;
}

interface DeleteNoteProps {
  noteSequenceNbr: string;
}

export const addNoteAction = createAction('[Notes] Add note', props<AddNoteProps>());

export const updateNoteAction = createAction('[Notes] Update note', props<UpdateNoteProps>());

export const deleteNoteAction = createAction('[Notes] Delete note', props<DeleteNoteProps>());
